export const licenceKey = {
    warning: 'f3a45cd615dee1fd3e528ad7583048fdb035fda7e1821921a640948638be9692',
    invalid: 'f3a45cd615dee1fd3e528ad7583048fdb035fda7e1821921a640948638be9691',
    valid: '75b19cd8fc817dbd875d2e4bbecb93a3297cfc2cb8cb3b2a77b525c210812962'
}